import React, { useCallback } from 'react';
import { Stack, Switch, Typography } from '@mui/material';
import PortalTooltip from './PortalTooltip';

const PortalSwitch = ({
  id,
  leftLabel,
  rightLabel,
  checked = false,
  onChange,
  disabled = false,
  readOnly = false,
  ariaLabel,
  tooltip,
  size = 'small',
  className = '',
  sx = {},
}) => {
  const handleChange = useCallback(
    (event) => {
      if (readOnly) return;
      if (onChange) onChange(event);
    },
    [readOnly, onChange],
  );

  const containerClass = [
    'myOdu__portalSwitch',
    disabled ? 'myOdu__portalSwitch--disabled' : '',
    readOnly ? 'myOdu__portalSwitch--readOnly' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const leftLabelId = leftLabel ? `${id}_label_left` : undefined;
  const rightLabelId = rightLabel ? `${id}_label_right` : undefined;

  const ariaLabelledBy = [leftLabelId, rightLabelId].filter(Boolean).join(' ') || undefined;

  const switchContent = (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      className={containerClass}
      sx={{ width: 'fit-content', ...sx }}
    >
      {leftLabel && (
        <Typography
          id={leftLabelId}
          component="span"
          className="myOdu__portalSwitch__label myOdu__portalSwitch__label--left"
        >
          {leftLabel}
        </Typography>
      )}

      <Switch
        id={id}
        size={size}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="myOdu__portalSwitch__switch"
        inputProps={{
          role: 'switch',
          'aria-checked': checked,
          'aria-label': ariaLabel,
          'aria-labelledby': !ariaLabel ? ariaLabelledBy : undefined,
          ...(readOnly && { 'aria-readonly': true }),
        }}
      />

      {rightLabel && (
        <Typography
          id={rightLabelId}
          component="span"
          className="myOdu__portalSwitch__label myOdu__portalSwitch__label--right"
        >
          {rightLabel}
        </Typography>
      )}
    </Stack>
  );

  if (tooltip) {
    return (
      <PortalTooltip id={`${id}__tooltip`} title={tooltip}>
        {switchContent}
      </PortalTooltip>
    );
  }

  return switchContent;
};

export default PortalSwitch;
